import { render, staticRenderFns } from "./teste.vue?vue&type=template&id=e253c87e"
import script from "./teste.vue?vue&type=script&lang=ts"
export * from "./teste.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports